// Precious-metal pairs priced via 1:1 tracking tokens on CoinGecko.
export const COMMODITIES = [
  { symbol: 'XAU', id: 'pax-gold', name: 'Gold (XAU/USD)', tv: 'OANDA:XAUUSD', icon: '/icons/xau.svg', aliases: ['XAU', 'GOLD', 'PAXG'] },
  { symbol: 'XAG', id: 'kinesis-silver', name: 'Silver (XAG/USD)', tv: 'OANDA:XAGUSD', icon: '/icons/xag.svg', aliases: ['XAG', 'SILVER', 'KAG'] },
  { symbol: 'XPT', id: 'gram-platinum', name: 'Platinum (XPT/USD)', tv: 'OANDA:XPTUSD', icon: '/icons/xpt.svg', aliases: ['XPT', 'PLATINUM', 'GRAMP'] },
];

export const getCommodity = (symbol) => {
  const sym = (symbol || '').toUpperCase();
  return COMMODITIES.find((c) => c.aliases.includes(sym));
};

export const getTradingViewSymbol = (symbol) =>
  getCommodity(symbol)?.tv || `BINANCE:${(symbol || '').toUpperCase()}USDT`;

export const getQuoteCurrency = (symbol) => (getCommodity(symbol) ? 'USD' : 'USDT');

export const formatPair = (symbol) => `${(symbol || '').toUpperCase()}/${getQuoteCurrency(symbol)}`;
